import * as Codegen from '../../common/generated-types'
import { SortOrder } from '../../common/generated-types'
import {
  CREATE_ASSETS,
  DELETE_ASSETS,
  GET_ASSET,
  GET_ASSET_LIST,
  UPDATE_ASSET
} from '../definitions/product-definitions'
import { BaseDataService } from './base-data.service'

export class AssetsDataService {
  constructor(private baseDataService: BaseDataService) {}

  getAssetList(take = 10, skip = 0) {
    return this.baseDataService.query<
      Codegen.GetAssetListQuery,
      Codegen.GetAssetListQueryVariables
    >(GET_ASSET_LIST, {
      options: {
        skip,
        take,
        sort: {
          createdAt: SortOrder.DESC
        }
      }
    })
  }

  getAsset(id: string) {
    return this.baseDataService.query<
      Codegen.GetAssetQuery,
      Codegen.GetAssetQueryVariables
    >(GET_ASSET, {
      id
    })
  }

  createAssets(files: File[]) {
    return this.baseDataService.mutate<
      Codegen.CreateAssetsMutation,
      Codegen.CreateAssetsMutationVariables
    >(CREATE_ASSETS, {
      input: files.map((file) => ({ file }))
    })
  }

  updateAsset(input: Codegen.UpdateAssetInput) {
    return this.baseDataService.mutate<
      Codegen.UpdateAssetMutation,
      Codegen.UpdateAssetMutationVariables
    >(UPDATE_ASSET, {
      input
    })
  }

  deleteAssets(ids: string[], force: boolean) {
    return this.baseDataService.mutate<
      Codegen.DeleteAssetsMutation,
      Codegen.DeleteAssetsMutationVariables
    >(DELETE_ASSETS, {
      input: {
        assetIds: ids,
        force
      }
    })
  }
}
